import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import PageLoader from './PageLoader';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
const ErrorPopUp = ({ modal, title, error, toggleModalFn, confirmText, cancelText, cancelColor, confirmColor, isLoading }) => {
    return (
        <div className='error-dialoge-section'>
            <Dialog
                open={modal}
                // onClose={toggleModalFn}
                aria-labelledby="scroll-dialog-title"
            >
                <DialogTitle id="scroll-dialog-title" style={{ color: 'red' }}>
                    {title ? title : 'Errors '}
                    <span><ErrorOutlineIcon style={{ color: 'red', marginBottom:"-5px" }} /></span>
                </DialogTitle>

                <DialogContent dividers={true}>
                    <div className="error-modal" style={isMobile ? { width: 'auto', padding: "0px" } : { minWidth: '400px', padding: "0px" }}>
                        <Paper style={{ padding: "10px" }}>
                            <ul className='list-inline'>
                                <li><b>Field : </b><span>{error?.error_field?.replace(/\b\w/g, c => c.toUpperCase())}</span></li>
                                <li><b>Message : </b><span>{error?.error_message}</span></li>
                            </ul>
                        </Paper>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={toggleModalFn} size='small' color={cancelColor ? cancelColor : 'secondary'}>{cancelText ? cancelText : 'Cancel'}</Button>
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </div>
    )
}
export default ErrorPopUp;
